import ComicsStoryComponent from "../worldMap/Comics/ComicsStoryComponent";

function ComicsViewerPopup({comicsSetting, closeComics}){

    return <div className={'ComicsViewerPopupContainer'}>
         <ComicsStoryComponent comicsSetting={comicsSetting} cpuStory={null}  closeComics={closeComics} />
    </div>
}
export default ComicsViewerPopup;